import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Overline, MaskedHeading } from "@/components/ui-bits";

const FAQS = [
  {
    q: "What does BAT Ear Research actually do?",
    a: "We're a licensed private investigation and due-diligence firm based in Accra, Ghana. We verify people, businesses, land, and documents — for clients abroad who need eyes on the ground, and for individuals and companies inside Ghana who need discreet investigation, business intelligence, or security & risk services. We also coordinate settlement work for people relocating to Ghana: citizenship, business setup, and relocation project management.",
  },
  {
    q: "How much does an investigation cost?",
    a: "Every case is scoped individually, so pricing depends on the type of investigation, its complexity, and how much on-the-ground work is involved. You'll get a clear, tailored quote on your free consultation — no surprises, no obligation.",
  },
  {
    q: "How long does an investigation take?",
    a: "Typically 3–21 days depending on scope. A quick verification takes 3–5 days; a comprehensive investigation with multiple site visits takes 14–21 days. We move as fast as accuracy allows.",
  },
  {
    q: "What if the investigation finds nothing wrong?",
    a: "That's a great outcome — you get to proceed with total confidence. My fee stays exactly the same whether I say 'proceed' or 'walk away.' You're paying for the truth, not a particular answer.",
  },
  {
    q: "How do I know my information stays confidential?",
    a: "Confidentiality is the foundation of investigative work. Your identity, your target, and our findings are never shared with anyone but you. 100% independent and confidential — always.",
  },
  {
    q: "What makes you different from a consultant or real estate agent?",
    a: "Agents and consultants often earn commissions on the deals they recommend. I don't sell property, broker deals, or take referral fees. I'm a licensed private investigator working only for you — that independence is your protection.",
  },
  {
    q: "Can you help with Ghanaian citizenship directly?",
    a: "We coordinate and guide clients through the citizenship application and residency processes — helping you understand the requirements, prepare the right documents, and navigate the steps with clarity. All statutory approvals are of course made by the appropriate Ghanaian authorities; we facilitate, we don't act on their behalf.",
  },
  {
    q: "Do you only work with people outside Ghana?",
    a: "No. In addition to serving diaspora investors and relocating families, we also serve individuals and businesses inside Ghana with private investigations, business intelligence, and security & risk consultancy. See our Local Services section for what we offer locally.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="relative bg-paper py-24 sm:py-32"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Overline index={9}>FAQ</Overline>
        </Reveal>
        <MaskedHeading
          tag="h2"
          className="mt-6 font-display font-bold text-navy leading-[1.05] tracking-tight text-3xl sm:text-4xl lg:text-5xl"
          lines={["Common Questions"]}
        />

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-navy/15"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger className="text-left font-display text-lg sm:text-xl text-navy hover:text-gold hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/70 leading-relaxed text-[15px] pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
